// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TabletIconSignature {
  Element: SVGSVGElement;
}

export const TabletIcon: TOC<TabletIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<g clip-path="url(#clip0_203_587)">
<path d="M18 2.00098H6C4.897 2.00098 4 2.89698 4 4.00098V20.001C4 21.105 4.897 22.001 6 22.001H18C19.103 22.001 20 21.105 20 20.001V4.00098C20 2.89698 19.103 2.00098 18 2.00098ZM18 4.00098V5.00098H6V4.00098H18ZM18 7.00098L18.001 17.001H6V7.00098H18ZM6 20.001V19.001H18.001V20.001H6Z"/>
<path d="M9 10.999C9.55228 10.999 10 10.5512 10 9.99896C10 9.44668 9.55228 8.99896 9 8.99896C8.44772 8.99896 8 9.44668 8 9.99896C8 10.5512 8.44772 10.999 9 10.999Z"/>
<path d="M9 13.999C9.55228 13.999 10 13.5512 10 12.999C10 12.4467 9.55228 11.999 9 11.999C8.44772 11.999 8 12.4467 8 12.999C8 13.5512 8.44772 13.999 9 13.999Z"/>
<path d="M12 10.999C12.5523 10.999 13 10.5512 13 9.99896C13 9.44668 12.5523 8.99896 12 8.99896C11.4477 8.99896 11 9.44668 11 9.99896C11 10.5512 11.4477 10.999 12 10.999Z"/>
<path d="M15 10.999C15.5523 10.999 16 10.5512 16 9.99896C16 9.44668 15.5523 8.99896 15 8.99896C14.4477 8.99896 14 9.44668 14 9.99896C14 10.5512 14.4477 10.999 15 10.999Z"/>
</g>
<defs>
<clipPath id="clip0_203_587">
<rect width="24" height="24"/>
</clipPath>
</defs>
</svg>
</template>;